/**
 * Single source of truth for route paths.
 * Use these constants instead of hardcoding strings across the app.
 */
export const ROUTES = {
  HOME: "/",

  PRODUCTS: "/products",
  PRODUCT_DETAIL: (documentId = ":documentId") => `/products/${documentId}`,

  DESIGNERS: "/designers",
  DESIGNER_DETAIL: (documentId = ":documentId") => `/designers/${documentId}`,

  ORDERS: "/orders",
  ORDER_DETAIL: (documentId = ":documentId") => `/orders/${documentId}`,

  CUSTOM_ORDERS: "/custom-orders",

  // A placed order is reached only by its private token — there are no
  // accounts, so this link (emailed, and remembered on the device) is the
  // only way back to it.
  TRACK: (token = ":token") => `/track/${token}`,
  TRACK_CUSTOM: (token = ":token") => `/track/custom/${token}`,

  ABOUT: "/about",
  CONTACT: "/contact",
};
